export default {
  common: {
    navBarLinks: {
      home: "Home",
      career: "Career",
      projects: "Projects",
      about: "About",
      contact: "Contact",
    },
    notFoundPage: {
      title: "404 - Page Not Found",
      description:
        "The page you are looking for may have been moved or deleted. Please check the URL or use the navigation menu to find the correct page.",
      button: "Back to Home",
    },
    technicalspecifications: "Technical Specifications",
    functionalspecifications: "Functional Specifications",
    skill: "Skills",
    skills: {
      react: "React",
      express: "Express",
      mongodb: "MongoDB",
      nodejs: "Node.js",
      tailwind: "Tailwind CSS",
      i18n: "i18n",
      framerMotion: "Framer-motion",
      javascript: "Javascript",
      nextjs: "Next.js",
      sass: "Sass",
      mui: "MUI",
      redux: "Redux",
      rtkQuery: "RTK Query",
      zustand: "Zustand",
      json: "JSON",
      html: "HTML",
      css: "CSS",
      emailjs: "EmailJS",
      npm: "Npm",
      git: "Git",
      github: "GitHub",
      figma: "Figma",
      threejs: "Three.js",
      vite: "Vite",
      tauri: "Tauri",
      gitkraken: "GitKraken",
      gitfork: "Git Fork",
      itDiagnostics: "IT diagnostics",
      pedagogy: "Pedagogy",
      solutionImplementation: "Solution implementation",
      communication: "Communication",
      hardwareAssistance: "Hardware assistance",
      softwareDeployment: "Software deployment",
      systemAdministration: "System administration",
      listeningSkills: "Listening skills",
      needsAnalysis: "Needs analysis",
      supportAndTutoring: "Support and tutoring",
      decisionMaking: "Decision making",
      animationTechniques: "Animation techniques",
      training: "Training",
      changeManagement: "Change management",
      qualityControl: "Quality control",
      processAnalysis: "Process analysis",
      electronicArchiving: "Electronic archiving",
      clientFollowUp: "Client follow-up",
      solutionSales: "Solution sales",
      legalAssistance: "Legal assistance",
      organizationalSkills: "Organizational skills",
      curiosity: "Curiosity",
      rigor: "Rigor",
      adaptability: "Adaptability",
      proactiveness: "Proactiveness",
      teamwork: "Teamwork",
      languageFR: "Français",
      languageEN: "English",
    },
  },
}
